// src/App.js
import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import AppHeader from './components/Header';
import AppFooter from './components/Footer';
import WritePost from './pages/WritePost';
import About from './pages/About';
import Archive from './pages/Archive';
import PostDetail from './pages/PostDetail'; // 新增
import NotFound from './pages/NotFound/index .jsx';
import Home from './pages/Home';

const App = () => {
  return (
    <Router>
      <div className="app">
        <AppHeader />
        <main style={{ minHeight: 'calc(100vh - 128px)', padding: '24px 0' }}>
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/archive" element={<Archive />} />
            <Route path="/post" element={<PostDetail />} /> {/* 新增 */}
            <Route path="/write" element={<WritePost />} />
            <Route path="/about" element={<About />} />
            <Route path="*" element={<NotFound />} />
          </Routes>
        </main>
        <AppFooter />
      </div>
    </Router>
  );
};

export default App;